// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"223c9786","186":"9d9eae05","225":"0445ab17","344":"c6b15ff0","372":"f6450366","377":"a374ac8f","630":"8352223c","738":"4d8165da","841":"1350bb5e","856":"8263deaf"}[chunkId] + ".chunk.js";
};